import { Container, Loader, Text } from '@mantine/core';

function PDFViewerNative({ fileUrl, loading, error }) {
  if (loading || error) {
    return (
      <Container
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}>
        {/* Loading */}
        {loading && !error && <Loader color="cyan" />}

        {/* Error */}
        {error && (
          <Text weight={500} color="red" size="md">
            {error && error?.message?.includes('404')
              ? 'Document not found.'
              : 'Failed to load document.'}
          </Text>
        )}
      </Container>
    );
  }

  return (
    <div
      style={{
        width: '100%',
        height: 'calc(100vh - 30px)',
        overflow: 'hidden',
        position: 'relative',
      }}>
      <object
        data={fileUrl}
        type="application/pdf"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}>
        <p>
          Your browser does not support PDFs. Please download the PDF to view
          it: <a href={fileUrl}>Download PDF</a>
        </p>
      </object>
    </div>
  );
}

export default PDFViewerNative;
